import { ensureAbsoluteUrl } from '../utils/url'

const SOCIAL_PLATFORMS = [
  { key: 'facebook_link', platform: 'facebook' },
  { key: 'instagram_link', platform: 'instagram' },
  { key: 'linkedin_link', platform: 'linkedin' },
  { key: 'youtube_link', platform: 'youtube' },
  { key: 'tiktok_link', platform: 'tiktok' },
]


export function buildSocialLinks(obj) {
  if (!obj) return []
  return SOCIAL_PLATFORMS.filter(({ key }) => obj[key])
    .map(({ platform, key }) => ({
      platform,
      href: ensureAbsoluteUrl(obj[key]),
      label: platform,
    }))
}

export { SOCIAL_PLATFORMS }
